export const mimeTypeIconMap = new Map<string[], string>([
  [['jpg', 'jpeg', 'png', 'gif'], 'fa-regular fa-duotone fa-file-image'],
  [['mp4', 'mov', 'avi'], 'fa-regular fa-duotone fa-file-video'],
  [['pdf'], 'fa-regular fa-duotone fa-file-pdf'],
  [['doc', 'docx'], 'fa-regular fa-duotone fa-file-word'],
  [['xls', 'xlsx'], 'fa-regular fa-duotone fa-file-excel'],
  [['ppt', 'pptx'], 'fa-regular fa-duotone fa-file-powerpoint'],
  [['txt'], 'fa-regular fa-duotone fa-file-txt']
]);

export function resolveFileIcon(mimeType: string): string {
    if (!mimeType) {
        return 'fa-regular fa-duotone fa-file';
    }
    for (const [types, icon] of mimeTypeIconMap) {
        if (types.some(type => mimeType.includes(type))) {
            return icon;
        }
    }
    return 'fa-regular fa-duotone fa-file';
}